import { Link } from "react-router-dom";

//Internal hyperlink
export function HLink({ text, to, icon, className, ...rest }) {
    return (
        <Link to={to ? to : "/"} className={`hover:text-light-5 text-light-link transition ${className}`} {...rest}>{icon} {text}</Link>
    )
}

// External hyperlink
export function EHLink({ text, to, icon, className, ...rest }) {
    return (
        <a href={to ? to : "/"} target="_blank" className={`hover:text-light-5 text-light-link transition ${className}`} {...rest}>{icon} {text}</a>
    )
}
/*
sample use

text="some text"
to="/some/location"
icon={<UilIcon  />}
className="classes"

*/